import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=2c648e5b&scoped=true&"
import script from "./qualification.vue?vue&type=script&lang=ts&"
export * from "./qualification.vue?vue&type=script&lang=ts&"
import style0 from "./qualification.vue?vue&type=style&index=0&id=2c648e5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c648e5b",
  null
  
)

export default component.exports